module.exports = __webpack_public_path__ + "img/stripe.02fa14cb.svg";